export default "/img/KZ.8c593490294c1999ec8d25479bdddaef.png";